import { useState } from "react";
import { Card, Label } from "@/design/primitives";
import { login } from "@/lib/ccApi";

// Sign-in card: one pass phrase, one cookie, thirty days. Shown only when needed.
export const AuthGate = ({ onSignedIn }) => {
  const [pin, setPin] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    if (!pin.trim() || busy) return;
    setBusy(true);
    setError(null);
    try {
      await login(pin.trim());
      // Cookie is set server-side at this point. Consumers render the gate without
      // an onSignedIn handler, so default to a reload: the fresh cookie makes every
      // board refetch return 200 and the gate unmounts naturally. (2026-10-29: Jeff
      // hit "e is not a function" here — onSignedIn was undefined and the TypeError
      // surfaced as the red error while the board stayed gated.)
      if (typeof onSignedIn === "function") {
        onSignedIn();
      } else {
        window.location.reload();
      }
    } catch (err) {
      setError(err.message || "That pass phrase didn't match.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <Card className="mx-auto max-w-md px-6 py-6" data-testid="cc-signin">
      <Label as="h3">Sign in to work the board</Label>
      <p className="mt-1.5 text-[0.875rem] leading-[1.45] text-os-ink-2">
        One pass phrase, remembered for a month on this computer.
      </p>
      <form onSubmit={submit} className="mt-4 flex gap-2">
        <input
          data-testid="cc-signin-input"
          type="password"
          value={pin}
          onChange={(e) => setPin(e.target.value)}
          placeholder="Pass phrase"
          autoFocus
          className="w-full rounded-md border border-os-border bg-white px-3 py-2 text-[0.9375rem] outline-none focus:border-os-border-strong"
        />
        <button
          type="submit"
          data-testid="cc-signin-button"
          disabled={busy || !pin.trim()}
          className="shrink-0 rounded-md bg-os-ink px-4 py-2 font-mono text-[0.75rem] text-white hover:opacity-90 disabled:opacity-50"
        >
          {busy ? "Checking…" : "Sign in"}
        </button>
      </form>
      {error && (
        <p data-testid="cc-signin-error" className="mt-2 text-[0.8125rem] text-os-red">
          {error}
        </p>
      )}
    </Card>
  );
};

export default AuthGate;